import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Reward from '../../lib/reward';
import RewardItem from './reward-item';

const UnstyledList = styled.ul`
    list-style-type: none;
`;

export default function RewardsList({ rewards, type, onRewardSelected }) {
    return (
        <section className="rewards-list">
            <UnstyledList className="rewards">
                {rewards && rewards.map(rewardData => {
                    const reward = new Reward(rewardData);
                    return (<RewardItem
                      type={type}
                      reward={reward}
                      onClick={() => onRewardSelected(reward, type)}
                    />);
                })}
            </UnstyledList>
        </section>
    );
}

RewardsList.propTypes = {
    type: PropTypes.string.isRequired,
    rewards: PropTypes.arrayOf(PropTypes.shape({
        campaignName: PropTypes.string.isRequired,
        reward: {
            amount: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
        },
        eventTimestamp: PropTypes.number.isRequired,
        averageDurationToCallback: PropTypes.number.isRequired,
        userHasContactedSupport: PropTypes.bool,
    })).isRequired,
    onRewardSelected: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/pages/status-overview/rewards-list.jsx